import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './ServicesView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout, Divider, Typography, Row, Button } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableServices from '../../../components/tableServices/tableServices';
import FormServices from '../../../components/formServices/formServices';
import Search from '../../../components/search/search';
import { PlusOutlined } from '@ant-design/icons';
const { Content } = Layout;
const { Title } = Typography;

const ServicesView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [filteredDataServices, setFilteredDataServices] = useState([]);
    const [dataServices, setDataServices] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [editingService, setEditingService] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        getServices();
    }, []);

    const getServices = () => {
        setShowLoading(true);
        setLoadingText("Cargando servicios...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/services/get-services/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataServices(data);
                setShowLoading(false);
                if (searchText) {
                    filterData(searchText, data)
                } else {
                    setFilteredDataServices(data);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para agregar un nuevo registro de servicio
    const addService = (serviceData) => {
        setShowLoading(true);
        setLoadingText("Agregando servicio...")

        const formData = new FormData();
        formData.append("srv_service", serviceData.srv_service);
        formData.append("srv_page_title", serviceData.srv_page_title);
        formData.append("srv_page_description", serviceData.srv_page_description);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.post(`${apiUrl}/services/create-service/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getServices();
                setIsModalVisible(false);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    // Función para actualizar un servicio
    const updateService = (srv_id, serviceData) => {
        setShowLoading(true);
        setLoadingText("Actualizando servicio...")

        const formData = new FormData();
        formData.append("srv_id", srv_id);
        formData.append("srv_service", serviceData.srv_service);
        formData.append("srv_page_title", serviceData.srv_page_title);
        formData.append("srv_page_description", serviceData.srv_page_description);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/services/update-service/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getServices();
                setEditingService(null);
                setIsModalVisible(false);
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para iniciar la edición de un servicio
    const handleEdit = (service) => {
        setEditingService(service);
        setIsModalVisible(true);
    };

    // Función para abrir el modal de creación
    const handleCreate = () => {
        setEditingService(null);
        setIsModalVisible(true);
    };

    // Función para editar el nombre de una service (DEPRECATED - mantenida para compatibilidad)
    const handleInputChangeTable = (srv_id, service) => {
        setShowLoading(true);
        setLoadingText("Guardando servicio...")

        const formData = new FormData();
        formData.append("srv_id", srv_id);
        formData.append("srv_service", service);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.put(`${apiUrl}/services/update-service/`, formData, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getServices();
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    // Función para eliminar un registro de service
    const handleDeleteTable = (srv_id) => {
        setShowLoading(true);
        setLoadingText("Eliminando servicio...")

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.delete(`${apiUrl}/services/delete-service/${srv_id}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Correcto");
                getServices();
                setShowLoading(false);
            })
            .catch(function (error) {
                showSwal(error, 0, "Error")
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, dataServices)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataServices(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.srv_service.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataServices(filtered);
        }
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <Title level={3} style={{ margin: 0 }}>Gestión de Servicios</Title>
                    <Button 
                        type="primary" 
                        icon={<PlusOutlined />}
                        onClick={handleCreate}
                    >
                        Crear Servicio
                    </Button>
                </div>
                <Search onSearch={onSearch} />
                <br />
                <TableServices 
                    data={filteredDataServices} 
                    handleEdit={handleEdit}
                    handleDelete={handleDeleteTable} 
                />
                
                <FormServices 
                    addService={addService} 
                    updateService={updateService}
                    editingService={editingService}
                    setEditingService={setEditingService}
                    isModalVisible={isModalVisible}
                    setIsModalVisible={setIsModalVisible}
                />
            </div>
        </Content>
    </div>
}

export default ServicesView;